// Stats sub pages
export const ENUM_STATS_PAGE = {
  stBhsi: 'stats',
  stBha: 'stats',
  stBhs: 'stats',
  stBmc: 'stats',
  stBmr6i: 'stats',
  stBm4: 'stats',
  stBmr4i: 'stats',
  stBmr: 'stats',
  stBmri: 'stats',
  stBmr50: 'stats',
  stBms: 'stats',
  stBtwt: 'stats',
  stBberi: 'stats',
  stBba: 'stats',
  stBber: 'stats',
  stBbsr: 'stats',
  stBbsri: 'stats',
  stBfiw: 'stats',
  stBbbf: 'stats',
  stBmrci: 'stats',
  stBfow: 'stats',
  stBm: 'stats',
  stTtr: 'stats',
  stTtr100: 'stats',
  stTtw: 'stats',
  stBmf: 'stats'
}
export const ENUM_AUCTION_PAGES = {
  ali: 'live',
  ac: 'completed',
  at: 'teams',
  an: 'news',
  al: 'live-blog',
  ap: 'players',
  ati: 'team-detail'
}
export const ENUM_SEO_SUBTYPE = {
  h: 'home',
  n: 'news',
  v: 'videos',
  f: 'fixtures',
  s: 'standings',
  t: 'teams',
  sq: 'squads',
  ar: 'archives',
  ft: 'fantasy-tips',
  sc: 'score-card',
  o: 'overs',
  far: 'fixtures-and-results',
  r: 'results',
  c: 'commentary',
  u: 'upcoming',
  st: 'stats',
  ...ENUM_AUCTION_PAGES,
  ...ENUM_STATS_PAGE
}

export const ENUM_SERIES_CATEGORY_PAGES = {
  h: 'home',
  n: 'news',
  v: 'videos',
  f: 'fixtures',
  s: 'points-table',
  st: 'stats',
  t: 'teams',
  sq: 'squads',
  ar: 'archives',
  ft: 'fantasy-tips',
  ...ENUM_AUCTION_PAGES
}

export const ENUM_CRICKET_SERIES_PAGES = {
  f: 'fixtures',
  s: 'points-table',
  st: 'stats',
  t: 'teams',
  sq: 'squads',
  ft: 'fantasy-tips'
}
